import InstitutionSchedule from "./InstitutionSchedule.vue";

export default {
  extends: InstitutionSchedule
};
